//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        cellLabel: {
            type: String,
            default: null
        },
        cellValue: {
            type: null,
            default: null
        },
        cellPlaceholder: {
            type: String,
            default: "请选择cellValue"
        },
        isLink: {
            type: Boolean,
            default: false,
        }
    },
    name: "sm-cell",
    data() {
        return {

        }
    },
    components: {

    }
}



// WEBPACK FOOTER //
// ./node_modules/smart_webview_ui/src/components/sm_cell/sm_cell.vue